import { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { detectLang } from "../i18n";
import "./Login.css";

const paises = {
  es: [
    { code: "AR", name: "🇦🇷 Argentina" },
    { code: "BO", name: "🇧🇴 Bolivia" },
    { code: "BR", name: "🇧🇷 Brasil" },
    { code: "CL", name: "🇨🇱 Chile" },
    { code: "CO", name: "🇨🇴 Colombia" },
    { code: "EC", name: "🇪🇨 Ecuador" },
    { code: "MX", name: "🇲🇽 México" },
    { code: "PY", name: "🇵🇾 Paraguay" },
    { code: "PE", name: "🇵🇪 Perú" },
    { code: "UY", name: "🇺🇾 Uruguay" },
    { code: "VE", name: "🇻🇪 Venezuela" },
    { code: "DE", name: "🇩🇪 Alemania" },
    { code: "AU", name: "🇦🇺 Australia" },
    { code: "ES", name: "🇪🇸 España" },
    { code: "FR", name: "🇫🇷 Francia" },
    { code: "GB", name: "🇬🇧 Reino Unido" },
    { code: "IT", name: "🇮🇹 Italia" },
    { code: "PT", name: "🇵🇹 Portugal" },
    { code: "US", name: "🇺🇸 Estados Unidos" },
    { code: "OTHER", name: "🌍 Otro" },
  ],
  en: [
    { code: "AR", name: "🇦🇷 Argentina" },
    { code: "BO", name: "🇧🇴 Bolivia" },
    { code: "BR", name: "🇧🇷 Brazil" },
    { code: "CL", name: "🇨🇱 Chile" },
    { code: "CO", name: "🇨🇴 Colombia" },
    { code: "EC", name: "🇪🇨 Ecuador" },
    { code: "MX", name: "🇲🇽 Mexico" },
    { code: "PY", name: "🇵🇾 Paraguay" },
    { code: "PE", name: "🇵🇪 Peru" },
    { code: "UY", name: "🇺🇾 Uruguay" },
    { code: "VE", name: "🇻🇪 Venezuela" },
    { code: "DE", name: "🇩🇪 Germany" },
    { code: "AU", name: "🇦🇺 Australia" },
    { code: "ES", name: "🇪🇸 Spain" },
    { code: "FR", name: "🇫🇷 France" },
    { code: "GB", name: "🇬🇧 United Kingdom" },
    { code: "IT", name: "🇮🇹 Italy" },
    { code: "PT", name: "🇵🇹 Portugal" },
    { code: "US", name: "🇺🇸 United States" },
    { code: "OTHER", name: "🌍 Other" },
  ],
};

const Registro = () => {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pais, setPais] = useState("");
  const [paisOtro, setPaisOtro] = useState("");
  const [error, setError] = useState("");
  const [lang, setLangState] = useState(detectLang());
  const navigate = useNavigate();

  const handleLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    const auth = getAuth();
    const db = getFirestore();

    const paisFinal = pais === "OTHER" ? paisOtro : pais;

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      if (user) {
        await setDoc(doc(db, "usuarios", user.uid), {
          nombre,
          email,
          pais: paisFinal,
          id: user.uid,
        });
        navigate("/biblioteca");
      }
    } catch (err) {
      setError(
        lang === "es"
          ? "Error al registrar. Verificá los datos e intentá de nuevo."
          : "Registration error. Please check your details and try again."
      );
    }
  };

  const listaPaises = paises[lang] || paises["es"];

  return (
   <div className="login-screen">
      <div className="login-left">

        <div className="lang-switcher">
  <button
    className={`lang-btn ${lang === "es" ? "active" : ""}`}
    onClick={() => handleLang("es")}
  >
    <img src="https://flagcdn.com/w20/es.png" alt="ES" style={{width:20, borderRadius:2}} />
  </button>
  <button
    className={`lang-btn ${lang === "en" ? "active" : ""}`}
    onClick={() => handleLang("en")}
  >
    <img src="https://flagcdn.com/w20/us.png" alt="EN" style={{width:20, borderRadius:2}} />
  </button>
</div>

        <div className="brand">
          <div className="brand-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <div className="brand-name">
            AFILIADOS<span>MARKET</span>
          </div>
        </div>

        <h1 className="login-title">
          {lang === "es" ? "Crear cuenta" : "Create account"}
        </h1>
        <p className="login-sub">
          {lang === "es"
            ? "Completá tus datos para comenzar"
            : "Fill in your details to get started"}
        </p>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleRegister}>
          <label className="field-label">
            {lang === "es" ? "Nombre" : "Name"}
          </label>
          <input
            className="field-input"
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder={lang === "es" ? "Tu nombre" : "Your name"}
            required
          />

          <label className="field-label">Email</label>
          <input
            className="field-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            required
          />

          <label className="field-label">
            {lang === "es" ? "País" : "Country"}
          </label>
          <div style={{ position: "relative", marginBottom: pais === "OTHER" ? "8px" : "16px" }}>
            <select
              className="field-input"
              value={pais}
              onChange={(e) => setPais(e.target.value)}
              required
              style={{ appearance: "none", cursor: "pointer" }}
            >
              <option value="">
                {lang === "es" ? "🌎 Seleccioná tu país" : "🌎 Select your country"}
              </option>
              {listaPaises.map((p) => (
                <option key={p.code} value={p.code}>{p.name}</option>
              ))}
            </select>
            <span style={{
              position: "absolute", right: 14, top: "50%",
              transform: "translateY(-50%)", color: "#6b6b9a", pointerEvents: "none"
            }}>▼</span>
          </div>

          {pais === "OTHER" && (
            <input
              className="field-input"
              type="text"
              value={paisOtro}
              onChange={(e) => setPaisOtro(e.target.value)}
              placeholder={lang === "es" ? "Escribí tu país aquí..." : "Type your country here..."}
              required
              style={{
                background: "linear-gradient(135deg, #13132a, #1a1040)",
                borderColor: "#a855f740",
                marginBottom: "16px",
              }}
            />
          )}

          <label className="field-label">
            {lang === "es" ? "Contraseña" : "Password"}
          </label>
          <input
            className="field-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          <button className="btn-primary" type="submit">
            <svg viewBox="0 0 24 24">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            {lang === "es" ? "Crear cuenta gratis" : "Create free account"}
          </button>
        </form>

        <div className="divider">
          <div className="divider-line"></div>
          <span className="divider-text">
            {lang === "es" ? "¿ya tenés cuenta?" : "already have an account?"}
          </span>
          <div className="divider-line"></div>
        </div>

        <button
          className="btn-secondary"
          onClick={() => navigate("/login")}
        >
          {lang === "es" ? "Iniciar sesión" : "Sign in"}
        </button>

      </div>
    </div>
  );
};

export default Registro;